import styled from 'styled-components';
import { Plus } from '@lt/components/icons-react';
import { Child } from '@lt/components/icons-react/userflow';
import { CONTAINER_QUERY_BREAKPOINTS } from '../../types';

export const Wrapper = styled.div<{ parentWidth?: number }>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  ${({ parentWidth }) => {
    if (parentWidth && parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minMd) {
      return `
        flex-wrap: nowrap;
        flex-direction: row;
        max-width: 180px;
      `;
    }

    return `
      flex-direction: column;
      align-items: flex-start;
    `;
  }}
`;
export const StyledPlus = styled<any>(Plus)`
  margin-left: 4px;
  transform: translateY(4px);
  width: 16px;
  height: 16px;
  ${({ parentWidth }) => {
    if (parentWidth && parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minMd) {
      return `
        width: 24px;
        height: 24px;
      `;
    }
    return '';
  }}
`;

export const AdultsWrapper = styled.div`
  margin-right: 4px;
`;

export const AdultsCount = styled.div`
  white-space: nowrap;
  font-style: normal;
  font-weight: 700;
  font-size: 1.375em;
  line-height: 1.375em;

  color: #17181a;
`;

export const AdultsLabel = styled.div<{ parentWidth?: number }>`
  white-space: nowrap;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;

  color: #919499;
  display: none;

  ${({ parentWidth }) => {
    if (parentWidth && parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minMd) {
      return `
        display: block;
      `;
    }
    return '';
  }}
`;

export const StyledChild = styled(Child)`
  margin-left: 2px;
  width: 16px;
  height: 30px;
`;

export const KidsCount = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 1.375em;
  line-height: 1.375em;
  white-space: nowrap;

  color: #17181a;
`;

export const KidsLabel = styled.div<{ parentWidth?: number }>`
  display: none;

  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;

  color: #919499;

  ${({ parentWidth }) => {
    if (parentWidth && parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minMd) {
      return `
       display: block;
      `;
    }
    return '';
  }}
`;

export const KidsAgesList = styled.div<{ parentWidth?: number }>`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;

  color: #919499;

  ${({ parentWidth }) => {
    if (parentWidth && parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minMd) {
      return `
        margin-left: 8px;
        padding-top: 6px;
      `;
    }
    return '';
  }}
`;

export const AdultsAndKidsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`;
